import React from 'react';
import CreateAgentForm from '../components/agent/CreateAgentForm';

const CreateAgentPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <CreateAgentForm />
    </div>
  );
};

export default CreateAgentPage;